import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, type Theme } from 'styles/theme';
import { blueSecondaryLink } from 'components/Globals/Base/Link/LinkStyles';

export const Container = styled.div`
  padding: 0 20px;

  

  @media (${breakpoint.mdMin}) {
    padding: 0 8px;
  }

  @media (${breakpoint.xlMin}) {
    padding: 0;
  }
`;

const customIframeStyles = css`
  margin: 0;
`;

export const ContentWrapper = styled.div<{ theme: Theme; $templateType: string }>`
  ${getBodyStyle('georgia', { default: 'default' })};

  p {
    margin: 24px 0;
  }

  .wp-block-image {
    figcaption {
      font-size: 14px;
      line-height: 140%;
      font-weight: 600;
      font-family: var(--graphik-compact);
      letter-spacing: 0px;
    }

    .image-credit {
      color: #626262;
      font-size: 12px;
      text-transform: uppercase;
      font-family: var(--graphik);
      line-height: 140%;
      letter-spacing: 0px;
    }
  }

  .wp-block-image:has(.alignleft) {
    float: left;
    width: 40% !important;
    margin-right: 16px !important;
    margin-top: 24px !important;
    margin-bottom: 8px !important;
    clear: both;

    figcaption {
      text-align: center;
    }

    .image-credit {
      text-align: center;
    }
  }

  .wp-block-image:has(.alignright) {
    float: right;
    width: 40% !important;
    margin-left: 16px !important;
    margin-top: 24px !important;
    margin-bottom: 8px !important;
    clear: both;

    figcaption {
      text-align: center;
    }

    .image-credit {
      text-align: center;
    }
  }
  

  // Restore list styling for branded articles
  ul, ol {
    list-style: revert;
    padding: revert;
    margin: revert;
  }

  @media(${breakpoint.mdMin}) {
    max-width: 704px;
    margin: 24px auto;
    ${({ $templateType }) => $templateType === 'custom-iframe' && customIframeStyles}
    
    .wp-block-image:has(.alignleft) {
      margin-right: 24px !important;
      margin-bottom: 16px !important;
    }

    .wp-block-image:has(.alignright) {
      margin-left: 24px !important;
      margin-bottom: 16px !important;
    }
  }

  @media(${breakpoint.lgMin}) {
    max-width: 633px;
    margin-top: 48px;
    ${({ $templateType }) => $templateType === 'custom-iframe' && customIframeStyles}
  }

  a {
    ${blueSecondaryLink}
  }
`;
